import config from '../../config/config';

import getRequest from './base/get';

export default {
  /**
   * Get charging point details by Id
   */
  getEndConsumerById: (id: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/consumer/${id}`);
  },
  /**
   * Fetch vehicle details of the consumer
   */
  fetchTransactionByUserCustomId: (id: string) => {
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/consumer-transaction-list/${id}`,
    );
  },
};
